import { render } from "./FormTextarea.vue?vue&type=template&id=959163da"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"
script.render = render

export default script